import { ItemOrderWorkflow, ItemStatus } from "common/types/catalog-types";
import { CatalogicalItem } from "common/types/catalogical-type";

export const NON_VENDABLE_SCORE_THRESHOLD = 0.58;

export const normalizeScore = (score: number): number => {
  if (score <= 0) return 0;
  const remainder = score % 1;
  return remainder === 0 ? 1 : remainder;
};

export const isNonVendable = (item: CatalogicalItem): boolean =>
  item.status?.toLowerCase() === ItemStatus.unsanctioned ||
  item.orderWorkflow?.toLowerCase() === ItemOrderWorkflow.NON_ORDERABLE_WORKFLOW;
